import type { ReactNode } from "react";
import { useMemo } from "react";
// import { useTranslation } from "react-i18next";
import { SvgIcon } from "@mui/material";
import HomeSmileIcon from "src/icons/untitled-ui/duocolor/home-smile";
import Users03Icon from "src/icons/untitled-ui/duocolor/users-03";
import { paths } from "src/paths";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
// import Diversity3Icon from '@mui/icons-material/Diversity3';
// import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import SettingsIcon from "@mui/icons-material/Settings";
// import ArticleIcon from "@mui/icons-material/Article"; // For Logs
import PersonIcon from "@mui/icons-material/Person";
// import GroupIcon from "@mui/icons-material/Group";
// import TuneIcon from "@mui/icons-material/Tune";
import WebhookIcon from "@mui/icons-material/Webhook";
import ApiIcon from "@mui/icons-material/Api";
import BarChartIcon from "@mui/icons-material/BarChart";
import CurrencyBitcoinIcon from "@mui/icons-material/CurrencyBitcoin";
// import File04Icon from '@untitled-ui/icons-react/build/esm/File04';
import BusinessIcon from "@mui/icons-material/Business";


export interface Item {
  disabled?: boolean;
  external?: boolean;
  icon?: ReactNode;
  items?: Item[];
  label?: ReactNode;
  path?: string;
  title: string;
}

export interface Section {
  items: Item[];
  subheader?: string;
}

export const useSections = () => {
  // const { t } = useTranslation();

  return useMemo(() => {
    return [
      {
        items: [
          {
            title: "Dash",
            path: paths.dashboard.index,
            icon: (
              <SvgIcon fontSize="small">
                <HomeSmileIcon />
              </SvgIcon>
            ),
          },
          {
            title: "Users",
            path: paths.dashboard.customers.index,
            icon: (
              <SvgIcon fontSize="small">
                <Users03Icon />
              </SvgIcon>
            ),
          },
          {
            title: "Tx",
            path: paths.dashboard.transactions.index,
            icon: (
              <SvgIcon fontSize="small">
                <AttachMoneyIcon />
              </SvgIcon>
            ),
          },

         
          
          {
            title: "Kyb",
            path: "/dashboard/kyb",
            icon: (
              <SvgIcon fontSize="small">
                <BusinessIcon />
              </SvgIcon>
            ),
          },
          // {
          //   title: "Logs",
          //   path: "/dashboard/log",
          //   icon: (
          //     <SvgIcon fontSize="small">
          //       <ArticleIcon />
          //     </SvgIcon>
          //   ),
          // },
          {
            title: "Setting",
            path: "/dashboard/setting",
            icon: (
              <SvgIcon fontSize="small">
                <SettingsIcon />
              </SvgIcon>
            ),
            items: [
              // {
              //   title: "Teams",
              //   path: "/dashboard/teams",
              //   icon: (
              //     <SvgIcon fontSize="small">
              //       <GroupIcon />
              //     </SvgIcon>
              //   ),
              // },
              // {
              //   title: "Config",
              //   path: "/dashboard/config",
              //   icon: (
              //     <SvgIcon fontSize="small">
              //       <TuneIcon />
              //     </SvgIcon>
              //   ),
              // },
              {
                title: "WebHooks",
                path: "/dashboard/webhooks",
                icon: (
                  <SvgIcon fontSize="small">
                    <WebhookIcon />
                  </SvgIcon>
                ),
              },
              {
                title: "Rates",
                path: "/dashboard/rating",
                icon: (
                  <SvgIcon fontSize="small">
                    <CurrencyBitcoinIcon />
                  </SvgIcon>
                ),
              },
              {
                title: "Status",
                path: "/dashboard/status",
                icon: (
                  <SvgIcon fontSize="small">
                    <BarChartIcon />
                  </SvgIcon>
                ),
              },
              {
                title: "Docs",
                path: "https://docs.swiftramp.in",
                external: true,
                icon: (
                  <SvgIcon fontSize="small">
                    <ApiIcon />
                  </SvgIcon>
                ),
              },
              {
                title: "Profile",
                path: "/dashboard/profile",
                icon: (
                  <SvgIcon fontSize="small">
                    <PersonIcon style={{ color: "orange" }} />
                  </SvgIcon>
                ),
              },
            ],
          },
        ],
      },
    ];
  }, []);
};
